export default "__VITE_ASSET__D7EBBDMC__"